export default __webpack_public_path__ + "static/media/nova-mensagem.78c95b24.mp3";